import { Button, Card, FormControlLabel, Paper, Stack, Switch, TextField, ToggleButton, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useGetPersonQuery, useUpdatePersonMutation, useGetPersonRecurring_bonusQuery } from '../../features/model/personSlice';
import Loading from '../../components/Loading';
import { RecurringBonusCard, AddRecurringBonusCard } from './RecurringBonusCard';
import { PersonPermissionsView } from './PermissionsView';
import { useState } from 'react';

const UpdatingTextField = ({label, defaultValue, data_key, updateMethod}) => {
    const [value, setValue] = useState(defaultValue);
    const changed = value !== defaultValue;

    const hitSave = () => {
        updateMethod(data_key, value);
    }

    return <Stack direction="row" spacing={2}>
        <TextField sx={{flexGrow: 1}} label={label} defaultValue={defaultValue} onChange={(e)=>{setValue(e.target.value)}} />
        {changed && <Button variant="contained" onClick={hitSave}>Save</Button>}
    </Stack>;
} 

const PersonView = () => {
    let params = useParams();

    const { data: object, error, isLoading } = useGetPersonQuery(params.objectId)
    const { data: recurringBonus, error: recurringBonusError, isLoading: isLoadingRecurringBonus } = useGetPersonRecurring_bonusQuery(params.objectId);

    const [updateObject, {isLoadingUpdate: isUpdating}] = useUpdatePersonMutation();

    if (isLoading || isUpdating) {
        return <Loading />;
    }

    var recurringBonusObjects = []
    if (recurringBonus) {
        recurringBonusObjects = recurringBonus.objects;
    }

    if (error) {
        return <div>Error: {error.error}</div>
    }

    function setMetaValue(key, value) {
        let datatype = key.split(":")[0];
        var meta = {...object.metadata};
        if (datatype === "int") {
            meta[key.split(":")[1]] = parseInt(value);
        } else if (datatype === "float") {
            meta[key.split(":")[1]] = parseFloat(value);
        } else {
            meta[key.split(":")[1]] = value;
        }
        updateObject({person_id: object.id, data: {metadata: JSON.stringify(meta)}});
    }

    function setValue(key, value) {
        updateObject({person_id: object.id, data: {[key]: value}});
    }

    return <Stack sx={{margin: 2}} spacing={2}>
        <Paper>
            <Card>
                <Stack direction="row">
                    <Stack direction="column" sx={{margin: 2}} spacing={2}>
                        <Typography variant='h2'>Person Details</Typography>
                        <TextField label="Name" defaultValue={object.name} sx={{width: 400}} disabled />
                        <UpdatingTextField label="Full Name" defaultValue={object.full_name} data_key="full_name" sx={{width: 400}} updateMethod={setValue} />
                        <UpdatingTextField label="Email" defaultValue={object.email} data_key="email" updateMethod={setValue} sx={{width: 400}} />
                        <UpdatingTextField label="PTO Days" defaultValue={`${JSON.parse(object.metadata).pto_days}`} data_key="int:pto_days" updateMethod={setMetaValue} sx={{width: 400}} />
                        <UpdatingTextField label="Department" defaultValue={object.department} data_key="department" updateMethod={setValue} sx={{width: 400}} />
                        <FormControlLabel sx={{width: 400}} control={<Switch defaultChecked={object.locked} onChange={(event) => {
                            setValue("locked", event.target.checked);
                        }} />} label={"Password locked"} />
                        <FormControlLabel sx={{width: 400}} control={<Switch defaultChecked={object.active} onChange={(event) => {
                            setValue("active", event.target.checked);
                        }} />} label={"Active"} />
                        <Stack direction="row" spacing={2}>
                            <TextField label="Failed Login Attempts" value={object.failed_attempts} sx={{width: 200}} />
                            <Button variant="outlined" onClick={() => {setValue("failed_attempts", 0);}}>Reset</Button>
                        </Stack>
                    </Stack>
                    <Stack direction="column" sx={{margin: 2}} spacing={2}>
                        <Typography variant='h2'>Permissions</Typography>
                        <PersonPermissionsView person={object} />
                    </Stack>
                </Stack>
            </Card>
        </Paper>
        <Paper>
            <Card>
                <Stack direction="column" sx ={{margin: 2}} spacing={2}>
                    <Typography variant='h2'>Recurring Bonuses</Typography>
                    {
                        recurringBonusObjects.slice().sort((a, b) => b.start_date.localeCompare(a.start_date)).map((recurringBonus, i) => <RecurringBonusCard key={recurringBonus.id} object={recurringBonus} />)
                    }
                    <AddRecurringBonusCard person={object}/>
                </Stack>
            </Card>
        </Paper>
    </Stack>
}

export default PersonView;